export enum StorageKeys {
  APP_VERSION = "MA1_appVersion",
  SELECTED_ASSET = "MA1_selectedAsset",
  ORIGIN_ACCOUNT = "MA1_originAccount",
  DESTINATION_ACCOUNT = "MA1_destinationAccount",
  SELECTED_MAINCHAIN_WALLET = "MA1_selectedMainchainWallet",
  DAPP_SETTINGS = "MA1_dappSettings",
}
